export default "__VITE_ASSET__fdfcc4f1__"